/* eslint jsx-a11y/anchor-is-valid: 0 */

import React, {useState, useEffect} from "react";
import { Link, useSearchParams } from "react-router-dom";
import {
  Button,
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormInput,
  FormTextarea,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "shards-react";
import {useParams} from "react-router-dom";
import moment, { localeData } from 'moment-timezone'
import { accessCheck } from "../../utils/tools";
import { WEB_PAYMENT_URL } from "../../environmentVariables";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faFileInvoiceDollar, 
  faClock, 
  faImages, 
  faExclamationTriangle, 
  faCheckCircle, 
  faTimesCircle, 
  faPercent, 
  faTimes, 
  faChevronLeft, 
  faChevronRight, 
  faEye, 
  faExternalLinkAlt, 
  faPrint, 
  faFile, 
  faDownload, 
  faEnvelope, 
  faPhone,
  faRobot,
  faQuestionCircle,
  faCommentDots
} from '@fortawesome/free-solid-svg-icons';

import PageTitle from "../../components/common/PageTitle";
import ActivityIndicator from "../../components/common/ActivityIndicator";
import Back from "../../components/common/Back";
import { acceptDispute } from "../../actions/locationActions";
import QRCode from "react-qr-code";
import AdjustBalanceModal from "../../components/common/AdjustBalanceModal";
import TrustScoreContainer from "../../components/DisputeTrustScore/TrustScoreContainer";
import { addCitationNote, respondDispute } from '../../actions/citationActions';
import firebase from 'firebase/compat/app';

const GLOBAL_CANNED_MESSAGES = [
  'Thank you for your dispute. Could you please provide additional evidence or documentation to support your claim?',
  'We have received your dispute and are reviewing it. If you have any further information, please reply to this email.',
  'Your dispute is under review. Please clarify your reason or provide more details so we can assist you better.'
];

const Citation = (props) => {

  let {violationNumber} = useParams();
  const [searchParams] = useSearchParams();
  const [citation, setCitation] = useState(null)
  const [location, setLocation] = useState(null);
  const [vehicleActivities, setVehicleActivities] = useState([])
  const [showAcceptModal, setShowAcceptModal] = useState(false)
  const [showAdjustModal, setShowAdjustModal] = useState(false)
  const [showRejectModal, setShowRejectModal] = useState(false)
  const [showVoidModal, setShowVoidModal] = useState(false)
  const [selectedPercentage, setSelectedPercentage] = useState(10)
  const [newAmount, setNewAmount] = useState(0)
  const [adjustmentNote, setAdjustmentNote] = useState(null)
  const [acceptNote, setAcceptNote] = useState(null)
  const [lightboxOpen, setLightboxOpen] = useState(false)
  const [currentImageIndex, setCurrentImageIndex] = useState(0)
  const [showPrintedCitation, setShowPrintedCitation] = useState(false)
  const [evidenceLightboxOpen, setEvidenceLightboxOpen] = useState(false)
  const [currentEvidenceIndex, setCurrentEvidenceIndex] = useState(0)
  const [currentEvidenceUrl, setCurrentEvidenceUrl] = useState('')
  const [currentEvidenceName, setCurrentEvidenceName] = useState('')
  const [aiRecommendation, setAiRecommendation] = useState(null)
  const [showPaymentMethodModal, setShowPaymentMethodModal] = useState(false)
  const [showNoteModal, setShowNoteModal] = useState(false);
  const [noteText, setNoteText] = useState('');
  const [isPlacementPhotoLightbox, setIsPlacementPhotoLightbox] = useState(false);
  const [savingNote, setSavingNote] = useState(false);
  const [showRespondModal, setShowRespondModal] = useState(false);
  const [selectedCannedMessage, setSelectedCannedMessage] = useState('');
  const [customMessage, setCustomMessage] = useState('');
  const [showActivityNote, setShowActivityNote] = useState(false);
  const [activityNoteContent, setActivityNoteContent] = useState('');
  const [citationClient, setCitationClient] = useState(null);
  const clientCannedMessages = (citationClient?.canned_dispute_messages || [])
    .filter(message => message.active !== false && message.message)
    .map(message => message.message);
  const cannedMessages = [
    ...GLOBAL_CANNED_MESSAGES,
    ...clientCannedMessages
  ];

  useEffect(() => {
    const clientId = citation?.client;
    if (!clientId) {
      setCitationClient(null);
      return;
    }
    const fromStore = props.clients?.find(client => client.id === clientId);
    if (fromStore) {
      setCitationClient(fromStore);
    }
    firebase
      .firestore()
      .collection('clients')
      .doc(clientId)
      .get()
      .then(doc => {
        if (doc.exists) {
          setCitationClient({id: doc.id, ...doc.data()});
        }
      })
      .catch(error => console.log('Could not load client canned messages:', error));
  }, [citation?.client])

  useEffect(() => {
    !accessCheck(props.user, 'citations') && (window.location.href = '/')
    props.getSingleCitation(violationNumber)
    return () => props.clearCitation()
  }, [])

  // Parse AI recommendation data from URL parameters
  useEffect(() => {
    const aiDataParam = searchParams.get('aiData');
    if (aiDataParam && props.user?.type === 'super') {
      try {
        const parsedData = JSON.parse(decodeURIComponent(aiDataParam));
        setAiRecommendation(parsedData);
      } catch (error) {
        console.error('Error parsing AI recommendation data:', error);
      }
    }
  }, [searchParams, props.user]);

  useEffect(() => {
    if (props.citation?.id) {
      setCitation(props.citation)
    }
  }, [props.citation])

  useEffect(() => {
    if (citation) {
      document.title = 'Citation: ' + citation.violation_number + ' - EnforcePlus admin';
      setLocation(props.locations.find(loc => loc.id === citation.location))
      props.getAllVehicleActivities(citation.location, citation.vehicle)
      //props.getAllVehicleActivities(citation.location, citation.vehicle)
    }
  }, [citation])

  useEffect(() => {
    setVehicleActivities(props.vehicleActivities?.length > 0 ? props.vehicleActivities.sort((a, b) => moment(a.created_at).isBefore(moment(b.created_at)) ? 1 : -1) : [])
  }, [props.vehicleActivities])

  useEffect(() => {
    if (citation) {
      let currentTotal = getCurrentTotal()
      setNewAmount(parseFloat(currentTotal / 100 * (100 - selectedPercentage)).toFixed(2))
    }
  }, [selectedPercentage, citation])

  

  const getCurrentTotal = () => {
    let applyEarlyBird = citation.early_bird_expiry && moment(citation.early_bird_expiry).isAfter(moment()) && citation.dispute?.status !== 'adjusted'
    let applyPenalty = citation.penalty_start_at && moment(citation.penalty_start_at).isBefore(moment())
    let totalToPay = citation.total
    if (applyEarlyBird) {
      totalToPay = citation.early_bird_total
    }
    if (applyPenalty) {
      totalToPay = citation.penalty_total
    }
    if (citation.payment?.amount) {
      totalToPay = citation.payment?.amount - (citation?.payment?.card_last_four ? citation.service_fee : 0)
    }
    if (citation.status === 'closed' || citation.status === 'void') {
      totalToPay = 0
    }
    return parseFloat(totalToPay).toFixed(2)
  }

  const onDisputeAccept = () => {
    let confirm = window.confirm('Are you sure you want to accept this dispute request?')
    if (confirm) {
      props.acceptDispute(citation, acceptNote)
      setAcceptNote(null)
      setCitation({...citation, dispute: {...citation.dispute, status: 'accepted'}, status: 'closed', total: parseFloat(0).toFixed(2)})      
      setShowAcceptModal(false)
    }
  }

  const onDisputeReject = () => {
    let confirm = window.confirm('Are you sure you want to reject this dispute request?')
    if (confirm) {
      props.rejectDispute(citation, adjustmentNote)
      setAdjustmentNote(null)
      setCitation({...citation, dispute: {...citation.dispute, status: 'rejected'}})
      setShowRejectModal(false)
    }
  }

  const onDisputeAdjust = () => {
    let confirm = window.confirm('Are you sure you want to adjust the balance?')
    if (confirm) {
      props.adjustDispute(citation, newAmount, adjustmentNote)
      setAdjustmentNote(null)
      setCitation({...citation, dispute: {...citation.dispute, status: 'adjusted'}, total: parseFloat(newAmount).toFixed(2)})
      setNewAmount(0)
      setShowAdjustModal(false)
    }
  }

  const onVoidCitation = () => {
    props.voidCitation(citation, adjustmentNote)
    if (citation.dispute) {
      setCitation({...citation, dispute: {...citation.dispute, status: 'accepted'}, status: 'void', total: parseFloat(0).toFixed(2), void_note: adjustmentNote})
    } else {
      setCitation({...citation, status: 'void', total: parseFloat(0).toFixed(2), void_note: adjustmentNote})
    }
    setAdjustmentNote(null)
    setShowVoidModal(false)
  }

  const renderRelatedActivity = () => {
    if (props.loadingVehicleActivities) {
      return (
        <div className="text-center py-5">
          <ActivityIndicator />
          <p className="mt-3 text-muted">Loading activity...</p>
        </div>
      )
    }
    if (props.loadedVehicleActivities) {
      // Collect all activities into a single array with a type and timestamp
      let activities = [];
      if (citation.disputed_on) {
        activities.push({
          type: 'DISPUTED',
          color: '#F98A01',
          label: 'DISPUTED',
          date: citation.disputed_on,
          user: citation.dispute?.name
        });
      }
      if (citation.created_at) {
        activities.push({
          type: 'CITED',
          color: '#7F8497',
          label: 'CITED',
          date: citation.created_at,
          user: props.users.find(user => user.id === citation.user)?.name
        });
      }
      if (citation.notes && citation.notes.length > 0) {
        // `citation.notes` is usually an array, but some older data shapes can be a string or a single object.
        if (Array.isArray(citation.notes)) {
          citation.notes.forEach(note => {
            activities.push({
              type: 'NOTE',
              color: '#21AA73',
              label: 'NOTE',
              date: note?.created_at || citation.created_at,
              user: note?.user,
              text: note?.text
            });
          });
        } else if (typeof citation.notes === 'string') {
          const noteText = citation.notes.trim();
          if (noteText) {
            activities.push({
              type: 'NOTE',
              color: '#21AA73',
              label: 'NOTE',
              date: citation.created_at || moment.utc().toISOString(),
              user: props.user?.name,
              text: noteText
            });
          }
        } else if (citation.notes && typeof citation.notes === 'object') {
          // Single note object (best-effort)
          activities.push({
            type: 'NOTE',
            color: '#21AA73',
            label: 'NOTE',
            date: citation.notes?.created_at || citation.created_at || moment.utc().toISOString(),
            user: citation.notes?.user || props.user?.name,
            text: citation.notes?.text || ''
          });
        }
      }
      if (props.vehicleActivities && props.vehicleActivities.length > 0) {
        props.vehicleActivities.forEach(activity => {
          activities.push({
            type: activity.activity_name.toUpperCase(),
            color: '#7F8497',
            label: activity.activity_name.toUpperCase(),
            date: activity.created_at,
            user: props.users.find(user => user.id === activity.user)?.name
          });
        });
      }
      if (citation.dispute?.accepted_on) {
        activities.push({
          type: 'ACCEPTED',
          color: '#21AA73',
          label: 'ACCEPTED',
          date: citation.dispute.accepted_on,
          user: props.users.find(user => user.id === citation.dispute?.accepted_by)?.name,
          note: citation.dispute?.accepted_note
        });
      }
      if (citation.dispute?.rejected_on) {
        activities.push({
          type: 'REJECTED',
          color: '#C81712',
          label: 'REJECTED',
          date: citation.dispute.rejected_on,
          user: props.users.find(user => user.id === citation.dispute?.rejected_by)?.name,
          note: citation.dispute?.rejected_note
        });
      }
      if (citation.dispute?.responded_on) {
        activities.push({
          type: 'RESPONDED',
          color: '#3498db',
          label: 'RESPONDED',
          date: citation.dispute.responded_on,
          user: props.users.find(user => user.id === citation.dispute?.responded_by)?.name,
          note: citation.dispute?.responded_message
        });
      }
      // Sort by date descending
      activities.sort((a, b) => new Date(b.date) - new Date(a.date));
      return (
        <div className="table-responsive">
          <table className="table mb-0">
            <thead className="bg-light">
              <tr>
                <th style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>ACTIVITY</th>
                <th style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>DATE/TIME</th>
                <th style={{color: '#818ea3', fontWeight: 500, fontSize: 13}}>USER</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {activities.map((activity, idx) => (
                <tr key={idx}>
                  <td style={{fontWeight: 500, color: activity.color}}>
                    {activity.label}
                    {/* Show note icon for accepted/rejected with note */}
                    {(activity.type === 'ACCEPTED' || activity.type === 'REJECTED') && activity.note && (
                      <FontAwesomeIcon
                        icon={faCommentDots}
                        className="ml-2"
                        style={{cursor: 'pointer', color: '#3498db'}}
                        title="View note sent to user"
                        onClick={() => {
                          setActivityNoteContent(activity.note);
                          setShowActivityNote(true);
                        }}
                      />
                    )}
                  </td>
                  <td>{moment(activity.date).format('MM/DD/YYYY h:mm a')}</td>
                  <td>{activity.user}</td>
                  <td style={{color: '#495057', fontSize: 14}}>{activity.text || ''}</td>
                </tr>
              ))}
            </tbody>
          </table>    
        </div>
      )
    }
  }

  const openLightbox = (index) => {
    setCurrentImageIndex(index);
    setIsPlacementPhotoLightbox(false);
    setLightboxOpen(true);
  }

  const openPlacementPhotoLightbox = () => {
    setCurrentImageIndex(0);
    setIsPlacementPhotoLightbox(true);
    setLightboxOpen(true);
  }

  const closeLightbox = () => {
    setLightboxOpen(false);
    setIsPlacementPhotoLightbox(false);
  }

  const nextImage = (e) => {
    e.stopPropagation();
    if (citation.images && citation.images.length > 0) {
      setCurrentImageIndex((currentImageIndex + 1) % citation.images.length);
    }
  }

  const prevImage = (e) => {
    e.stopPropagation();
    if (citation.images && citation.images.length > 0) {
      setCurrentImageIndex((currentImageIndex - 1 + citation.images.length) % citation.images.length);
    }
  }

  const openEvidenceLightbox = (url, name, index) => {
    setCurrentEvidenceUrl(url);
    setCurrentEvidenceName(name);
    setCurrentEvidenceIndex(index);
    setEvidenceLightboxOpen(true);
  }

  const closeEvidenceLightbox = () => {
    setEvidenceLightboxOpen(false);
  }

  const nextEvidence = (e) => {
    e.stopPropagation();
    if (citation.dispute?.evidence && citation.dispute.evidence.length > 0) {
      const nextIndex = (currentEvidenceIndex + 1) % citation.dispute.evidence.length;
      setCurrentEvidenceIndex(nextIndex);
      setCurrentEvidenceUrl(citation.dispute.evidence[nextIndex].url);
      setCurrentEvidenceName(citation.dispute.evidence[nextIndex].name);
    }
  }

  const prevEvidence = (e) => {
    e.stopPropagation();
    if (citation.dispute?.evidence && citation.dispute.evidence.length > 0) {
      const prevIndex = (currentEvidenceIndex - 1 + citation.dispute.evidence.length) % citation.dispute.evidence.length;
      setCurrentEvidenceIndex(prevIndex);
      setCurrentEvidenceUrl(citation.dispute.evidence[prevIndex].url);
      setCurrentEvidenceName(citation.dispute.evidence[prevIndex].name);
    }
  }

  const isImageFile = (url) => {
    const extension = url.split('.').pop().toLowerCase();
    return ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].includes(extension);
  }

  const isPdfFile = (url) => {
    const extension = url.split('.').pop().toLowerCase();
    return ['pdf'].includes(extension);
  }

  const openPrintedCitation = () => {
    setShowPrintedCitation(true);
  }

  const closePrintedCitation = () => {
    setShowPrintedCitation(false);
  }

  const openInNewTab = () => {
    window.open(WEB_PAYMENT_URL + '/citation/' + citation.violation_number, '_blank');
  }

  const handlePaymentMethodSelection = (paymentMethod) => {
    props.markAsPaid(citation, paymentMethod.toLowerCase())
    setCitation({
      ...citation, 
      status: "closed",
      payment_on: moment.utc().toISOString(),
      payment: {
        type: paymentMethod.toLowerCase(),
        amount: parseFloat(citation.violations_total).toFixed(2)
      }
    })
    setShowPaymentMethodModal(false);
  }

  const handleAddNote = async () => {
    if (!noteText.trim()) return;
    setSavingNote(true);
    await props.addCitationNote(citation, noteText, props.user);
    setNoteText('');
    setShowNoteModal(false);
    setSavingNote(false);
  };

  const handleRespond = async () => {
    if (!customMessage.trim()) return;
    await props.respondDispute(citation, customMessage);
    setShowRespondModal(false);
    setCustomMessage('');
    setSelectedCannedMessage('');
  };

  if (citation) {
    return (
      <Container fluid className="main-content-container px-4">
        <style>
          {`
            .citation-card {
              border-radius: 6px;
              box-shadow: 0 1px 10px rgba(0,0,0,0.05);
              border: 1px solid #eaedf3;
              overflow: hidden;
            }
            
            .citation-card .card-header {
              background-color: #fff;
              border-bottom: 1px solid #eaedf3;
              padding: 16px 20px;
              display: flex;
              align-items: center;
              justify-content: space-between;
            }
            
            .card-title {
              margin: 0;
              font-weight: 600;
              font-size: 16px;
              color: #3D5170;
              display: flex;
              align-items: center;
            }
            
            .card-title .icon {
              margin-right: 10px;
              color: #21AA73;
              opacity: 0.8;
            }
            
            .status-badge {
              display: inline-block;
              padding: 4px 12px;
              border-radius: 50px;
              font-size: 12px;
              font-weight: 500;
              text-transform: uppercase;
            }
            
            .status-badge.open {
              background-color: rgba(33, 170, 115, 0.1);
              color: #21AA73;
            }
            
            .status-badge.disputed {
              background-color: rgba(249, 138, 1, 0.1);
              color: #F98A01;
            }
            
            .status-badge.void {
              background-color: rgba(200, 23, 18, 0.1);
              color: #C81712;
            }
            
            .status-badge.closed {
              background-color: rgba(127, 132, 151, 0.1);
              color: #7F8497;
            }
            
            .action-button {
              border-radius: 4px;
              font-weight: 500;
              transition: all 0.2s ease;
              padding: 8px 16px;
              font-size: 14px;
            }
            
            .action-button.adjust {
              background-color: #FAD100;
              border-color: #FAD100;
              color: #000;
            }
            
            .action-button.adjust:hover {
              background-color: #e6bf00;
              border-color: #e6bf00;
            }
            
            .action-button.accept {
              background-color: #21AA73;
              border-color: #21AA73;
              color: #fff;
            }
            
            .action-button.accept:hover {
              background-color: #1d9966;
              border-color: #1d9966;
            }
            
            .action-button.reject {
              background-color: #C81712;
              border-color: #C81712;
              color: #fff;
            }
            
            .action-button.reject:hover {
              background-color: #b41510;
              border-color: #b41510;
            }
            
            .action-button.void {
              background-color: #000000;
              border-color: #000000;
              color: #fff;
            }
            
            .action-button.void:hover {
              background-color: #333;
              border-color: #333;
            }
            
            .percentage-button {
              cursor: pointer;
              height: 60px;
              width: 90px;
              border-radius: 5px;
              display: flex;
              align-items: center;
              justify-content: center;
              transition: all 0.2s ease;
              border: 1px solid #dfe3e9;
              background-color: #f8f9fa;
            }
            
            .percentage-button.active {
              background-color: rgba(249, 138, 1, 0.1);
              border-color: #F98A01;
            }
            
            .percentage-button.active span {
              color: #F98A01;
              font-weight: 500;
            }
            
            .percentage-button:hover:not(.active) {
              border-color: #c8cbd3;
              background-color: #f1f3f5;
            }
            
            .field-label {
              font-size: 11px;
              text-transform: uppercase;
              color: #818ea3;
              margin-bottom: 4px;
              font-weight: 500;
            }
            
            .field-value {
              font-size: 14px;
              color: #495057;
            }
            
            .info-section {
              margin-bottom: 16px;
            }
            
            .table td {
              vertical-align: middle;
            }
            
            .photo-thumbnail {
              height: 100px;
              border-radius: 6px;
              overflow: hidden;
              box-shadow: 0 2px 5px rgba(0,0,0,0.1);
              cursor: pointer;
              transition: all 0.2s ease;
            }
            
            .photo-thumbnail:hover {
              transform: translateY(-2px);
              box-shadow: 0 4px 8px rgba(0,0,0,0.15);
            }
            
            .lightbox-overlay {
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-color: rgba(0, 0, 0, 0.85);
              z-index: 2000;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            
            .lightbox-content {
              position: relative;
              max-width: 90%;
              max-height: 90%;
            }
            
            .lightbox-image {
              max-width: 100%;
              max-height: 85vh;
              border-radius: 4px;
              box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
            }
            
            .lightbox-close {
              position: absolute;
              top: -40px;
              right: 0;
              color: white;
              font-size: 20px;
              cursor: pointer;
              background: none;
              border: none;
              width: 40px;
              height: 40px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 50%;
              transition: background-color 0.2s ease;
            }
            
            .lightbox-close:hover {
              background-color: rgba(255, 255, 255, 0.1);
            }
            
            .lightbox-nav {
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              color: white;
              background: rgba(0, 0, 0, 0.5);
              width: 40px;
              height: 40px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 50%;
              cursor: pointer;
              border: none;
              transition: background-color 0.2s ease;
            }
            
            .lightbox-nav:hover {
              background-color: rgba(0, 0, 0, 0.8);
            }
            
            .lightbox-nav.prev {
              left: -50px;
            }
            
            .lightbox-nav.next {
              right: -50px;
            }
            
            .lightbox-counter {
              position: absolute;
              bottom: -30px;
              left: 0;
              right: 0;
              text-align: center;
              color: white;
              font-size: 14px;
            }
            
            .citation-modal .modal-content {
              border-radius: 6px;
              border: none;
              box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
            }
            
            .citation-modal .modal-header {
              background-color: #fff;
              border-bottom: 1px solid #eaedf3;
              padding: 16px 20px;
            }
            
            .citation-modal .modal-title {
              font-weight: 600;
              color: #3D5170;
              display: flex;
              align-items: center;
            }
            
            .citation-modal .modal-title .icon {
              margin-right: 10px;
              color: #21AA73;
            }
            
            .citation-modal .modal-body {
              padding: 0;
            }
            
            .citation-modal .modal-footer {
              border-top: 1px solid #eaedf3;
              padding: 12px 20px;
            }
            
            .citation-iframe {
              border: none;
              width: 100%;
              height: 80vh;
            }
            
            .view-citation-btn {
              transition: all 0.2s ease;
              border-radius: 4px;
              padding: 12px 24px;
              font-weight: 500;
              width: 100%;
              text-align: center;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 0;
              background-color: #f8f9fa;
              border: 1px solid #dfe3e9;
              color: #495057;
            }
            
            .view-citation-btn:hover {
              background-color: #e9ecef;
              border-color: #dfe3e9;
              color: #21AA73;
            }
            
            .view-citation-btn .icon {
              margin-right: 8px;
              color: #818ea3;
            }
            
            .view-citation-btn:hover .icon {
              color: #21AA73;
            }
            
            .evidence-item {
              display: flex;
              align-items: center;
              padding: 8px 12px;
              border-radius: 4px;
              border: 1px solid #eaedf3;
              background-color: #f8f9fa;
              margin-bottom: 8px;
              cursor: pointer;
              transition: all 0.2s ease;
            }
            
            .evidence-item:hover {
              background-color: #e9ecef;
              border-color: #dfe3e9;
            }
            
            .evidence-item .icon {
              color: #21AA73;
              margin-right: 12px;
            }
            
            .evidence-name {
              font-size: 14px;
              color: #495057;
              flex: 1;
            }
            
            .evidence-embed {
              width: 100%;
              height: 80vh;
              border: none;
              border-radius: 4px;
              box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
            }
            
            .evidence-actions {
              position: absolute;
              bottom: -50px;
              left: 0;
              right: 0;
              display: flex;
              justify-content: center;
              gap: 10px;
            }
            
            .evidence-action-btn {
              background: rgba(255, 255, 255, 0.2);
              color: white;
              border: none;
              border-radius: 4px;
              padding: 8px 16px;
              cursor: pointer;
              display: flex;
              align-items: center;
              font-size: 14px;
              transition: background-color 0.2s ease;
            }
            
            .evidence-action-btn:hover {
              background: rgba(255, 255, 255, 0.3);
            }
            
            .evidence-action-btn .icon {
              margin-right: 8px;
            }
            
            .lightbox-title {
              position: absolute;
              top: -40px;
              left: 0;
              color: white;
              font-size: 14px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 70%;
            }
            
            .dispute-name-container {
              display: flex;
              align-items: center;
            }
            
            .email-icon, .phone-icon {
              margin-left: 8px;
              color: #21AA73;
              transition: all 0.2s ease;
              font-size: 14px;
              display: inline-block;
            }
            
            .email-icon:hover, .phone-icon:hover {
              transform: scale(1.2);
            }
            
            /* Tooltip styles */
            .tooltip-icon {
              cursor: pointer;
              margin-left: 5px;
              color: #818ea3;
              transition: color 0.2s ease;
            }
            
            .tooltip-icon:hover {
              color: #3498db;
            }
            
            .tooltip-container {
              position: relative;
              display: inline-flex;
              align-items: center;
            }
            
            .tooltip-content {
              position: absolute;
              top: 100%;
              left: 50%;
              transform: translateX(-50%);
              background-color: #fff;
              border: 1px solid #eaedf3;
              border-radius: 4px;
              padding: 10px;
              width: 200px;
              z-index: 1000;
              box-shadow: 0 2px 8px rgba(0,0,0,0.1);
              opacity: 0;
              visibility: hidden;
              transition: opacity 0.2s, visibility 0.2s;
            }
            
            .tooltip-container:hover .tooltip-content {
              opacity: 1;
              visibility: visible;
            }
            
            .tooltip-title {
              font-size: 14px;
              font-weight: 600;
              color: #495057;
              margin-bottom: 5px;
            }
            
            .tooltip-content p {
              margin: 0;
              font-size: 12px;
              color: #818ea3;
            }
            
            .tooltip-content::before {
              content: "";
              position: absolute;
              top: -6px;
              left: 50%;
              transform: translateX(-50%) rotate(45deg);
              width: 12px;
              height: 12px;
              background-color: #fff;
              border-left: 1px solid #eaedf3;
              border-top: 1px solid #eaedf3;
            }
            
            .tooltip-content[style*="right: 0"] {
              transform: none;
            }
            
            .tooltip-content[style*="right: 0"]::before {
              left: auto;
              right: 10px;
              transform: rotate(45deg);
            }
            
            .action-button.note:hover, .action-button.note:focus {
              background-color: #217dbb !important;
              border-color: #217dbb !important;
              color: #fff !important;
            }
            .action-button.adjust:hover, .action-button.adjust:focus {
              background-color: #e6bf00 !important;
              border-color: #e6bf00 !important;
              color: #000 !important;
            }
            .action-button.paid:hover, .action-button.paid:focus {
              background-color: #178a5c !important;
              border-color: #178a5c !important;
              color: #fff !important;
            }
            .action-button.void:hover, .action-button.void:focus {
              background-color: #b8321a !important;
              border-color: #b8321a !important;
              color: #fff !important;
            }
          `}
        </style>

        {/* Photo Lightbox */}
        {lightboxOpen && ((citation.images && citation.images.length > 0) || (isPlacementPhotoLightbox && citation.placement_photo)) && (
          <div className="lightbox-overlay" onClick={closeLightbox}>
            <div className="lightbox-content">
              <button className="lightbox-close" onClick={closeLightbox}>
                <FontAwesomeIcon icon={faTimes} />
              </button>
              <img 
                src={isPlacementPhotoLightbox ? citation.placement_photo : citation.images[currentImageIndex].url} 
                alt={isPlacementPhotoLightbox ? "Vehicle placement" : "Citation evidence"} 
                className="lightbox-image" 
                onClick={(e) => e.stopPropagation()}
              />
              {!isPlacementPhotoLightbox && citation.images.length > 1 && (
                <>
                  <button className="lightbox-nav prev" onClick={prevImage}>
                    <FontAwesomeIcon icon={faChevronLeft} />
                  </button>
                  <button className="lightbox-nav next" onClick={nextImage}>
                    <FontAwesomeIcon icon={faChevronRight} />
                  </button>
                  <div className="lightbox-counter">
                    {currentImageIndex + 1} / {citation.images.length}
                  </div>
                </>
              )}
              {isPlacementPhotoLightbox && (
                <div className="lightbox-counter">
                  1 / 1
                </div>
              )}
              {((!isPlacementPhotoLightbox && citation.images[currentImageIndex].created_at) || (isPlacementPhotoLightbox && citation.placement_photo_updated_at)) && (
                <div className="lightbox-timestamp" style={{
                  position: 'absolute',
                  bottom: '-60px',
                  left: 0,
                  right: 0,
                  textAlign: 'center',
                  color: 'white',
                  fontSize: '14px',
                  backgroundColor: 'rgba(0,0,0,0.5)',
                  padding: '5px 10px',
                  borderRadius: '4px',
                  marginTop: '10px'
                }}>
                  <FontAwesomeIcon icon={faClock} className="mr-2" />
                  {moment(isPlacementPhotoLightbox ? citation.placement_photo_updated_at : citation.images[currentImageIndex].created_at).format('MM/DD/YYYY h:mm:ss a')}
                </div>
              )}
            </div>
          </div>
        )}

        {/* Evidence Lightbox */}
        {evidenceLightboxOpen && citation.dispute?.evidence && citation.dispute.evidence.length > 0 && (
          <div className="lightbox-overlay" onClick={closeEvidenceLightbox}>
            <div className="lightbox-content">
              <div className="lightbox-title">{currentEvidenceName}</div>
              <button className="lightbox-close" onClick={closeEvidenceLightbox}>
                <FontAwesomeIcon icon={faTimes} />
              </button>
              
              {isImageFile(currentEvidenceUrl) ? (
                <img 
                  src={currentEvidenceUrl} 
                  alt="Evidence" 
                  className="lightbox-image" 
                  onClick={(e) => e.stopPropagation()}
                />
              ) : isPdfFile(currentEvidenceUrl) ? (
                <iframe 
                  src={currentEvidenceUrl} 
                  className="evidence-embed"
                  title="Evidence document"
                  onClick={(e) => e.stopPropagation()}
                />
              ) : (
                <div style={{
                  color: 'white', 
                  textAlign: 'center', 
                  padding: '20px',
                  backgroundColor: 'rgba(0,0,0,0.5)',
                  borderRadius: '8px'
                }}>
                  <FontAwesomeIcon icon={faFile} size="3x" style={{marginBottom: '15px'}} />
                  <p>This file type cannot be previewed in the browser.</p>
                </div>
              )}
              
              {citation.dispute.evidence.length > 1 && (
                <>
                  <button className="lightbox-nav prev" onClick={prevEvidence}>
                    <FontAwesomeIcon icon={faChevronLeft} />
                  </button>
                  <button className="lightbox-nav next" onClick={nextEvidence}>
                    <FontAwesomeIcon icon={faChevronRight} />
                  </button>
                  <div className="lightbox-counter">
                    {currentEvidenceIndex + 1} / {citation.dispute.evidence.length}
                  </div>
                </>
              )}
              
              <div className="evidence-actions">
                <a 
                  href={currentEvidenceUrl} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="evidence-action-btn"
                  onClick={(e) => e.stopPropagation()}
                >
                  <FontAwesomeIcon icon={faExternalLinkAlt} className="icon" />
                  Open in New Tab
                </a>
                <a 
                  href={currentEvidenceUrl} 
                  download={currentEvidenceName} 
                  className="evidence-action-btn"
                  onClick={(e) => e.stopPropagation()}
                >
                  <FontAwesomeIcon icon={faDownload} className="icon" />
                  Download
                </a>
              </div>
            </div>
          </div>
        )}
        
        {/* Page Header */}
  
        {/* First Row of Posts */}
        <Row>
          <Col>
            <Row noGutters className="page-header py-4">
              <Col xs="12" className='d-flex align-items-center flex-nowrap'>
                <Back className="mr-3" />
                <PageTitle title={"Citation: " + citation.violation_number} className="mb-0 mr-3 text-nowrap" />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Card small className="mb-4 citation-card">
                  <CardHeader>
                    <h6 className="card-title">
                      <FontAwesomeIcon icon={faFileInvoiceDollar} className="icon" />
                      Citation Details
                    </h6>
                    <div className="ml-auto">
                      <div 
                        className={`status-badge ${citation.status === 'closed' || citation.payment_on ? 'closed' : citation.status === 'open' && citation.disputed_on ? 'disputed' : citation.status === 'void' ? 'void' : 'open'}`}>
                        {citation.status === 'closed' || citation.payment_on ? 'CLOSED' : citation.status === 'open' && citation.disputed_on ? 'DISPUTED' : citation.status === 'void' ? 'VOID' : 'OPEN'}
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody className="p-0">
                    <div className="p-4" style={{backgroundColor: '#f8f9fa', borderBottom: '1px solid #eaedf3'}}>
                      <Row>
                        <Col xs={6}>
                          <div className="field-label">Original Balance</div>
                          <div style={{fontSize: 24, fontWeight: 500, color: '#3D5170'}}>${parseFloat(citation.violations_total).toFixed(2)}</div>
                        </Col>
                        <Col xs={6}>
                          <div className="field-label">{citation.payment_on ? 'Paid' : 'Current'} Balance {!!citation.payment_on && '(ex. fees)'}</div>
                          <div style={{fontSize: 24, fontWeight: 500, color: '#21AA73'}}>${getCurrentTotal()}</div>
                        </Col>
                      </Row>
                    </div>
                    <div className="p-4">
                      <div className="info-section">
                        <Row>
                          <Col md={6}>
                            <div className="field-label">Client</div>
                            <div className="field-value">{citation.client_name}</div>
                          </Col>
                          <Col md={6}>
                            <div className="field-label">Location</div>
                            <div className="field-value">{citation.location_name}</div>
                          </Col>
                        </Row>
                      </div>
                      <div className="info-section">
                        <Row>
                          <Col md={6}>
                            <div className="field-label">License Plate</div>
                            <div className="field-value" style={{fontWeight: "500"}}>
                              {citation.license_plate}
                            </div>
                            {(citation.car_color || citation.car_make || citation.car_type) && (
                              <div
                                className="field-value"
                                style={{
                                  marginTop: 4,
                                  fontSize: 12,
                                  color: '#818ea3'
                                }}
                              >
                                {[citation.car_color, citation.car_make, citation.car_type]
                                  .filter(Boolean)
                                  .join(' • ')}
                              </div>
                            )}
                          </Col>
                          <Col md={6}>
                            <div className="field-label">Date/Time</div>
                            <div className="field-value d-flex align-items-center">
                              <FontAwesomeIcon icon={faClock} className="mr-2" style={{color: '#818ea3', fontSize: '14px'}} />
                              {moment(citation.created_at).format('MM/DD/YYYY h:mm a')}
                            </div>
                          </Col>
                        </Row>
                      </div>
                      <div className="info-section">
                        <Row>
                          <Col md={6}>
                            <div className="field-label">Officer</div>
                            <div className="field-value">{props.users.find(user => user.id === citation.user)?.name || 'Unknown'}</div>
                          </Col>
                          <Col md={6}></Col>
                        </Row>
                      </div>
                      {citation.payment_on && (
                        <div className="info-section mt-3">
                          <div className="field-label mb-2">Payment Information</div>
                          <Row>
                            <Col md={6}>
                              <div className="field-label" style={{fontSize: '10px'}}>Name</div>
                              <div className="field-value">{citation.payment.name}</div>
                            </Col>
                            <Col md={6}>
                              <div className="field-label" style={{fontSize: '10px'}}>Email</div>
                              <div className="field-value">{citation.payment.email}</div>
                            </Col>
                          </Row>
                          <Row className="mt-2">
                            <Col md={6}>
                              <div className="field-label" style={{fontSize: '10px'}}>Payment Method</div>
                              <div className="field-value" style={{textTransform: 'capitalize'}}>
                                {citation.payment.type || 'Other'}
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="field-label" style={{fontSize: '10px'}}>Payment Date</div>
                              <div className="field-value">
                                {moment(citation.payment_on).format('MM/DD/YYYY h:mm a')}
                              </div>
                            </Col>
                          </Row>
                        </div>
                      )}
                    </div>
                    <div className="p-4" style={{borderTop: '1px solid #eaedf3'}}>
                      <div className="field-label mb-3">Violations</div>
                      {citation.violations.map((violation, index) => (
                        <Row key={index} className={index !== citation.violations.length - 1 ? 'mb-2' : ''}>
                          <Col xs={8}>
                            <div className="field-value">{violation.name}</div>
                          </Col>
                          <Col xs={4} className="text-right">
                            <div className="field-value" style={violation?.amount > 0 ? {fontWeight: 500} : {color: '#F98A01', fontWeight: 500}}>
                              {violation?.amount > 0 ? '$' + parseFloat(violation.amount).toFixed(2) : 'WARNING'}
                            </div>
                          </Col>
                        </Row>
                      ))}
                    </div>
                    {citation.images?.length > 0 && (
                      <div className="p-4" style={{borderTop: '1px solid #eaedf3'}}>
                        <div className="field-label mb-3 d-flex align-items-center">
                          <FontAwesomeIcon icon={faImages} className="mr-2" style={{color: '#818ea3'}} />
                          Photos
                        </div>
                        <Row>
                          {citation.images.map((image, index) => (
                            <Col key={index} xs={6} md={4} className="mb-3">
                              <div className="photo-thumbnail" onClick={() => openLightbox(index)}>
                                <img src={image.url} alt="Citation evidence" style={{width: '100%', height: '100%', objectFit: 'cover'}} />
                              </div>
                              {image.created_at && (
                                <div className="photo-timestamp" style={{
                                  fontSize: '11px', 
                                  color: '#818ea3', 
                                  textAlign: 'center',
                                  marginTop: '4px'
                                }}>
                                  <FontAwesomeIcon icon={faClock} className="mr-1" />
                                  {moment(image.created_at).format('MM/DD/YYYY h:mm a')}
                                </div>
                              )}
                            </Col>
                          ))}
                        </Row>
                      </div>
                    )}
                    {citation.placement_photo && (
                      <div className="p-4" style={{borderTop: '1px solid #eaedf3'}}>
                        <div className="field-label mb-3 d-flex align-items-center">
                          <FontAwesomeIcon icon={faImages} className="mr-2" style={{color: '#818ea3'}} />
                          Placement Photo
                        </div>
                        <Row>
                          <Col xs={6} md={4} className="mb-3">
                            <div className="photo-thumbnail" onClick={openPlacementPhotoLightbox}>
                              <img src={citation.placement_photo} alt="Vehicle placement" style={{width: '100%', height: '100%', objectFit: 'cover'}} />
                            </div>
                            {citation.placement_photo_updated_at && (
                              <div className="photo-timestamp" style={{
                                fontSize: '11px', 
                                color: '#818ea3', 
                                textAlign: 'center',
                                marginTop: '4px'
                              }}>
                                <FontAwesomeIcon icon={faClock} className="mr-1" />
                                {moment(citation.placement_photo_updated_at).format('MM/DD/YYYY h:mm a')}
                              </div>
                            )}
                          </Col>
                        </Row>
                      </div>
                    )}
                    <div className="p-4" style={{borderTop: '1px solid #eaedf3'}}>
                      <div className="field-label mb-3 d-flex align-items-center">
                        <FontAwesomeIcon icon={faPrint} className="mr-2" style={{color: '#818ea3'}} />
                        Printed Citation
                      </div>
                      <Row>
                        <Col xs={12}>
                          <button className="view-citation-btn" onClick={openPrintedCitation}>
                            <FontAwesomeIcon icon={faEye} className="icon" />
                            View Printed Citation
                          </button>
                        </Col>
                      </Row>
                    </div>
                  </CardBody>
                </Card>
                {(!!citation?.public_notes || !!citation.private_notes) && (
                  <Card small className="mb-4 citation-card">
                    <CardHeader>
                      <h6 className="card-title">Notes</h6>
                    </CardHeader>
                    <CardBody>
                      {!!citation?.public_notes && (
                        <div className="info-section">
                          <div className="field-label">Public notes</div>
                          <div className="field-value">{citation?.public_notes}</div>
                        </div>
                      )}
                      {!!citation?.private_notes && (
                        <div className="info-section">
                          <div className="field-label">Private notes</div>
                          <div className="field-value">{citation?.private_notes}</div>
                        </div>
                      )}
                    </CardBody>
                  </Card>
                )}
              </Col>
              <Col md={6}>
                {citation.disputed_on && (
                  <Card small className="mb-4 citation-card">
                    <div className="p-0">
                      <div style={{
                        backgroundColor: '#F98A01',
                        padding: '16px 20px',
                        color: 'white',
                        borderTopLeftRadius: '6px',
                        borderTopRightRadius: '6px',
                        position: 'relative'
                      }}>
                        <div className="d-flex align-items-center justify-content-between">
                          <h6 className="m-0 d-flex align-items-center" style={{fontWeight: 600, fontSize: '18px', color: 'white'}}>
                            <FontAwesomeIcon icon={faExclamationTriangle} className="mr-2" style={{color: 'white'}} />
                            DISPUTED
                          </h6>
                          <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                            <span style={{fontSize: '14px', color: 'white'}}>
                              {moment(citation.disputed_on).format('MM/DD/YYYY h:mm a')}
                            </span>
                            {/* Status stamp for accepted/rejected */}
                            {citation.dispute?.status === 'accepted' && (
                              <span style={{
                                background: '#21AA73',
                                color: 'white',
                                borderRadius: 999,
                                padding: '6px 22px',
                                fontWeight: 700,
                                fontSize: 15,
                                letterSpacing: 1,
                                marginLeft: 8,
                                display: 'inline-block',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                              }}>
                                ACCEPTED
                              </span>
                            )}
                            {citation.dispute?.status === 'rejected' && (
                              <span style={{
                                background: '#C81712',
                                color: 'white',
                                borderRadius: 999,
                                padding: '6px 22px',
                                fontWeight: 700,
                                fontSize: 15,
                                letterSpacing: 1,
                                marginLeft: 8,
                                display: 'inline-block',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                              }}>
                                REJECTED
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <CardBody className="p-4">
                        <div className="info-section">
                          <Row>
                            <Col md={6}>
                              <div className="field-label">Name</div>
                              <div className="field-value">
                                <span id="disputerName">{citation.dispute?.name}</span>
                              </div>
                            </Col>
                            <Col md={6}>
                              <div className="field-label">Email</div>
                              <div className="field-value dispute-name-container">
                                {citation.dispute?.email}
                                {citation.dispute?.email && (
                                  <a 
                                    href={`mailto:${citation.dispute?.email}`}
                                    className="email-icon"
                                    title={`Email ${citation.dispute?.name}`}
                                  >
                                    <FontAwesomeIcon icon={faEnvelope} size="sm" />
                                  </a>
                                )}
                              </div>
                            </Col>
                          </Row>
                        </div>
                        {citation.dispute?.address && (
                          <div className="info-section">
                            <div className="field-label">Address</div>
                            <div className="field-value" style={{
                              backgroundColor: '#f8f9fa', 
                              padding: '10px', 
                              borderRadius: '4px', 
                              border: '1px solid #eaedf3'
                            }}>
                              {typeof citation.dispute.address === 'string' ? (
                                citation.dispute.address
                              ) : (
                                <>
                                  {citation.dispute.address.address && (
                                    <div>{citation.dispute.address.address}</div>
                                  )}
                                  {(citation.dispute.address.city || citation.dispute.address.state || citation.dispute.address.zipCode) && (
                                    <div>
                                      {citation.dispute.address.city && citation.dispute.address.city}
                                      {citation.dispute.address.city && citation.dispute.address.state && ', '}
                                      {citation.dispute.address.state && citation.dispute.address.state}
                                      {citation.dispute.address.zipCode && ` ${citation.dispute.address.zipCode}`}
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        )}
                        {!!citation?.dispute?.mobile && (
                          <div className="info-section">
                            <div className="field-label">Mobile</div>
                            <div className="field-value dispute-name-container">
                              <span>{citation.dispute?.mobile}</span>
                              <a 
                                href={`tel:${citation.dispute?.mobile}`}
                                className="phone-icon"
                                title={`Call ${citation.dispute?.name}`}
                              >
                                <FontAwesomeIcon icon={faPhone} size="sm" />
                              </a>
                            </div>
                          </div>
                        )}
                        <div className="info-section">
                          <div className="field-label">Reason for dispute</div>
                          <div className="field-value" style={{backgroundColor: '#f8f9fa', padding: '10px', borderRadius: '4px', borderLeft: '3px solid #F98A01'}}>
                            {citation.dispute?.reason}
                          </div>
                        </div>
                        {citation.dispute?.evidence?.length > 0 && (
                          <div className="info-section">
                            <div className="field-label">Evidence attached</div>
                            <div className="field-value">
                              {citation.dispute.evidence.map((evidence, index) => {
                                if (!evidence?.name || !evidence?.url) return null;
                                return (
                                  <div key={index} 
                                       className="evidence-item"
                                       onClick={() => openEvidenceLightbox(evidence.url, evidence?.name, index)}>
                                    <FontAwesomeIcon icon={faFile} className="icon" />
                                    <span className="evidence-name">{evidence?.name}</span>
                                    <FontAwesomeIcon icon={faEye} style={{color: '#818ea3'}} />
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}
                        {/* Trust Score Analysis and AI Recommendation - Side by Side */}
                        <Row className="mt-4 mb-4">
                          {/* Trust Score Analysis */}
                          <Col md={props.user?.type === 'super' && aiRecommendation ? 6 : 12}>
                            <div className="field-label mb-2">Trust Analysis</div>
                            <TrustScoreContainer 
                              email={citation.dispute?.email} 
                              name={citation.dispute?.name} 
                            />
                          </Col>
                          {/* AI Recommendation */}
                          {props.user?.type === 'super' && aiRecommendation && (
                            <Col md={6}>
                              <div className="field-label mb-2">AI Recommendation</div>
                              <Card className="border h-100">
                                <CardBody className="p-3">
                                  <div className="d-flex align-items-center mb-3">
                                    <div
                                      style={{
                                        width: "36px",
                                        height: "36px",
                                        borderRadius: "50%",
                                        backgroundColor: aiRecommendation.action.toLowerCase().includes('accept') ? 'rgba(33, 170, 115, 0.1)' :
                                                         aiRecommendation.action.toLowerCase().includes('adjust') ? 'rgba(52, 152, 219, 0.1)' :
                                                         'rgba(200, 23, 18, 0.1)',
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        marginRight: "12px",
                                      }}
                                    >
                                      <FontAwesomeIcon
                                        icon={
                                          aiRecommendation.action.toLowerCase().includes('accept') ? faCheckCircle :
                                          aiRecommendation.action.toLowerCase().includes('adjust') ? faPercent :
                                          faTimesCircle
                                        }
                                        style={{
                                          color: aiRecommendation.action.toLowerCase().includes('accept') ? '#21AA73' :
                                                 aiRecommendation.action.toLowerCase().includes('adjust') ? '#3498db' :
                                                 '#C81712',
                                        }}
                                      />
                                    </div>
                                    <div>
                                      <div className="d-flex align-items-center">
                                        <div style={{ fontWeight: "600", fontSize: "14px" }}>
                                          {aiRecommendation.action}
                                        </div>
                                        <div className="tooltip-container ml-2">
                                          <FontAwesomeIcon
                                            icon={faQuestionCircle}
                                            className="tooltip-icon"
                                          />
                                          <div className="tooltip-content" style={{ 
                                            left: 'auto', 
                                            right: '0', 
                                            top: 'calc(100% + 5px)',
                                            width: '220px',
                                            transform: 'none'
                                          }}>
                                            <div className="tooltip-title">Recommendation Rationale</div>
                                            <p>{aiRecommendation.reason}</p>
                                            <p className="mb-0" style={{fontSize: '11px', color: '#818ea3'}}>
                                              Based on customer history and similar cases
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        style={{
                                          fontSize: "12px",
                                          color: "#818ea3",
                                        }}
                                      >
                                        {aiRecommendation.confidence}% confidence score
                                      </div>
                                    </div>
                                  </div>
                                  <Button
                                    block
                                    theme={
                                      aiRecommendation.action.toLowerCase().includes('accept') ? 'success' :
                                      aiRecommendation.action.toLowerCase().includes('adjust') ? 'info' :
                                      aiRecommendation.action.toLowerCase().includes('reject') ? 'danger' : 'success'
                                    }
                                    size="sm"
                                    onClick={() => {
                                      if (aiRecommendation.action.toLowerCase().includes('accept')) {
                                        setShowAcceptModal(true);
                                      } else if (aiRecommendation.action.toLowerCase().includes('reject')) {
                                        setShowRejectModal(true);
                                      } else if (aiRecommendation.action.toLowerCase().includes('adjust')) {
                                        setShowAdjustModal(true);
                                      }
                                    }}
                                    style={{
                                      boxShadow: 'none',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      fontWeight: '500'
                                    }}
                                  >
                                    <FontAwesomeIcon 
                                      icon={
                                        aiRecommendation.action.toLowerCase().includes('accept') ? faCheckCircle :
                                        aiRecommendation.action.toLowerCase().includes('adjust') ? faPercent :
                                        faTimesCircle
                                      }
                                      className="mr-2" 
                                    />
                                    Apply Recommendation
                                  </Button>
                                </CardBody>
                              </Card>
                            </Col>
                          )}
                        </Row>
                        {/* Dispute Action Buttons */}
                        {citation.dispute.status === 'open' && (
                          <div className="mt-4">
                            <div className="field-label mb-3">Dispute Actions</div>
                            <Row>
                              <Col xs={6} className="mb-2">
                                <Button
                                  theme="success"
                                  className="action-button accept w-100"
                                  onClick={() => setShowAcceptModal(true)}
                                >
                                  <FontAwesomeIcon icon={faCheckCircle} className="mr-2" />
                                  Accept Dispute
                                </Button>
                              </Col>
                              <Col xs={6} className="mb-2">
                                <Button
                                  theme="danger"
                                  className="action-button reject w-100"
                                  onClick={() => setShowRejectModal(true)}
                                >
                                  <FontAwesomeIcon icon={faTimesCircle} className="mr-2" />
                                  Reject Dispute
                                </Button>
                              </Col>
                            </Row>
                            <Row>
                              <Col xs={12} className="mb-2">
                                <Button
                                  theme="info"
                                  className="action-button respond w-100"
                                  onClick={() => setShowRespondModal(true)}
                                >
                                  <FontAwesomeIcon icon={faEnvelope} className="mr-2" />
                                  Respond
                                </Button>
                              </Col>
                            </Row>
                          </div>
                        )}
                      </CardBody>
                    </div>
                  </Card>
                )}
                <Card small className="mb-4 citation-card">
                  <CardHeader className="d-flex justify-content-between align-items-center">
                    <h6 className="card-title mb-0">Actions</h6>
                  </CardHeader>
                  <CardBody className="p-4" style={{paddingRight: '2.5rem', paddingLeft: '2.5rem'}}>
                    <Row className="mb-3" style={{ justifyContent: 'center' }}>
                      <Col xs={12} md={3} className="text-center mb-2 mb-md-0">
                        <Button
                          style={{ backgroundColor: '#FAD100', borderColor: '#FAD100', color: '#000', minWidth: 120, height: 40, margin: '0 6px', fontWeight: 500, padding: '0.5rem 1rem', borderRadius: 8, fontSize: 13 }}
                          className="action-button adjust w-100"
                          theme=""
                          onClick={() => setShowAdjustModal(true)}
                          disabled={['accepted','rejected'].includes(citation.dispute?.status)}
                        >
                          <FontAwesomeIcon icon={faPercent} className="mr-2" />
                          Adjust
                        </Button>
                      </Col>
                      <Col xs={12} md={3} className="text-center mb-2 mb-md-0">
                        <Button
                          style={{ backgroundColor: '#3498db', borderColor: '#3498db', color: '#fff', minWidth: 120, height: 40, margin: '0 6px', fontWeight: 500, padding: '0.5rem 1rem', borderRadius: 8, fontSize: 13 }}
                          className="action-button note w-100"
                          theme=""
                          onClick={() => setShowNoteModal(true)}
                        >
                          <FontAwesomeIcon icon={faCommentDots} className="mr-2" />
                          Add Note
                        </Button>
                      </Col>
                      <Col xs={12} md={3} className="text-center mb-2 mb-md-0">
                        <Button
                          style={{ backgroundColor: '#21AA73', borderColor: '#21AA73', color: '#fff', minWidth: 120, height: 40, margin: '0 6px', fontWeight: 500, padding: '0.5rem 1rem', borderRadius: 8, fontSize: 13 }}
                          className="action-button paid w-100"
                          theme=""
                          onClick={() => setShowPaymentMethodModal(true)}
                          disabled={citation.payment_on || citation.status === 'closed' || citation.status === 'void' || ['accepted','rejected'].includes(citation.dispute?.status)}
                        >
                          <FontAwesomeIcon icon={faCheckCircle} className="mr-2" />
                          Mark as Paid
                        </Button>
                      </Col>
                      <Col xs={12} md={3} className="text-center">
                        <Button
                          style={{ backgroundColor: '#E6492E', borderColor: '#E6492E', color: '#fff', minWidth: 120, height: 40, margin: '0 6px', fontWeight: 500, padding: '0.5rem 1rem', borderRadius: 8, fontSize: 13 }}
                          className="action-button void w-100"
                          theme=""
                          onClick={() => setShowVoidModal(true)}
                        >
                          <FontAwesomeIcon icon={faTimesCircle} className="mr-2" />
                          Void Citation
                        </Button>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                
                <Card small className="mb-4 citation-card">
                  <CardHeader>
                    <h6 className="card-title">
                      <FontAwesomeIcon icon={faClock} className="icon" />
                      Related Activity
                    </h6>
                  </CardHeader>
                  <CardBody className="p-0">
                    {renderRelatedActivity()}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>

        {/* Citation Viewer Modal */}
        <Modal
          open={showPrintedCitation}
          toggle={closePrintedCitation}
          size="lg"
          centered
          className="citation-modal"
        >
          <ModalHeader toggle={closePrintedCitation}>
            <FontAwesomeIcon icon={faPrint} className="icon mr-2" />
            Printed Citation
          </ModalHeader>
          <ModalBody>
            <iframe 
              src={WEB_PAYMENT_URL + '/citation/' + citation.violation_number} 
              className="citation-iframe"
              title="Printed Citation"
            />
          </ModalBody>
          <ModalFooter>
            <Button theme="light" onClick={closePrintedCitation} className="mr-2">
              Close
            </Button>
            <Button theme="accent" onClick={openInNewTab}>
              <FontAwesomeIcon icon={faExternalLinkAlt} className="mr-2" />
              Open in New Tab
            </Button>
          </ModalFooter>
        </Modal>

        {/* Replace the existing adjust modal with the shared component */}
        <AdjustBalanceModal 
          isOpen={showAdjustModal}
          toggle={() => setShowAdjustModal(false)}
          citation={citation}
          onAdjust={(citation, amount, note) => {
            props.adjustDispute(citation, amount, note);
            setAdjustmentNote(null);
            setCitation({...citation, dispute: {...citation.dispute, status: 'adjusted'}, total: parseFloat(amount).toFixed(2)});
            setNewAmount(0);
          }}
        />
        
        <Modal size={'md'} open={showRejectModal}>
          <ModalHeader toggle={() => setShowRejectModal(false)}>Reject Dispute</ModalHeader>
          <ModalBody className={'pt-4 pb-6'}>
            <Row>
              <Col xs={12}>
                <label htmlFor="feRejectionNote" className="field-label">Rejection Note (seen by customer)</label>
                <FormTextarea
                  id={'adjust-note'}
                  value={adjustmentNote}
                  onChange={(event) => setAdjustmentNote(event.target.value)}
                  style={{height: 100}}
                />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter style={{display: 'block !important'}}>
            <Row fluid>
              <Col xs={6} className={'text-left'}>
                <Button
                  theme="light"
                  onClick={() => setShowRejectModal(false)}
                  className={'mr-2'}
                >Cancel</Button>
              </Col>
              <Col xs={6} className={'text-right'}>
                <Button
                  theme="accent"
                  onClick={() => onDisputeReject()}
                >Reject Dispute</Button>
              </Col>
            </Row>
          </ModalFooter>
        </Modal>  
        <Modal size={'md'} open={showAcceptModal}>
          <ModalHeader toggle={() => setShowAcceptModal(false)}>Accept Dispute</ModalHeader>
          <ModalBody className={'pt-4 pb-6'}>
            <Row>
              <Col xs={12}>
                <label htmlFor="feAcceptNote" className="field-label">Accept Note (seen by customer)</label>
                <FormTextarea
                  id={'accept-note'}
                  value={acceptNote}
                  onChange={(event) => setAcceptNote(event.target.value)}
                  style={{height: 100}}
                />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter style={{display: 'block !important'}}>
            <Row fluid>
              <Col xs={6} className={'text-left'}>
                <Button
                  theme="light"
                  onClick={() => setShowAcceptModal(false)}
                  className={'mr-2'}
                >Cancel</Button>
              </Col>
              <Col xs={6} className={'text-right'}>
                <Button
                  theme="accent"
                  onClick={() => onDisputeAccept()}
                >Accept Dispute</Button>
              </Col>
            </Row>
          </ModalFooter>
        </Modal>  
        <Modal size={'md'} open={showVoidModal}>
          <ModalHeader toggle={() => setShowVoidModal(false)}>Void Citation</ModalHeader>
          <ModalBody className={'pt-4 pb-6'}>
            <Row>
              <Col xs={12}>
                <label htmlFor="feVoidNote" className="field-label">Void Note</label>
                <FormTextarea
                  id={'adjust-note'}
                  value={adjustmentNote}
                  onChange={(event) => setAdjustmentNote(event.target.value)}
                  style={{height: 100}}
                />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter style={{display: 'block !important'}}>
            <Row fluid>
              <Col xs={6} className={'text-left'}>
                <Button
                  theme="light"
                  onClick={() => setShowVoidModal(false)}
                  className={'mr-2'}
                >Cancel</Button>
              </Col>
              <Col xs={6} className={'text-right'}>
                <Button
                  theme="accent"
                  onClick={() => onVoidCitation()}
                >Void Citation</Button>
              </Col>
            </Row>
          </ModalFooter>
        </Modal>  

        {/* Payment Method Selection Modal */}
        <Modal 
          open={showPaymentMethodModal} 
          toggle={() => setShowPaymentMethodModal(!showPaymentMethodModal)}
          size="sm"
        >
          <ModalHeader toggle={() => setShowPaymentMethodModal(!showPaymentMethodModal)}>
            <FontAwesomeIcon icon={faFileInvoiceDollar} className="mr-2" style={{ color: '#21AA73' }} />
            Select Payment Method
          </ModalHeader>
          <ModalBody className="p-4">
            <p className="text-muted mb-3">
              Citation #{citation?.violation_number}
            </p>
            <p className="mb-4">
              How was this citation paid?
            </p>
            <div className="d-flex flex-column" style={{ gap: '12px' }}>
              <Button 
                theme="light" 
                block
                style={{
                  padding: '15px 20px',
                  border: '2px solid #eaedf3',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#495057',
                  backgroundColor: '#fff',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = '#21AA73';
                  e.target.style.color = '#21AA73';
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = '#eaedf3';
                  e.target.style.color = '#495057';
                }}
                onClick={() => handlePaymentMethodSelection('Check')}
              >
                Check
              </Button>
              <Button 
                theme="light" 
                block
                style={{
                  padding: '15px 20px',
                  border: '2px solid #eaedf3',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#495057',
                  backgroundColor: '#fff',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = '#21AA73';
                  e.target.style.color = '#21AA73';
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = '#eaedf3';
                  e.target.style.color = '#495057';
                }}
                onClick={() => handlePaymentMethodSelection('Cash')}
              >
                Cash
              </Button>
              <Button 
                theme="light" 
                block
                style={{
                  padding: '15px 20px',
                  border: '2px solid #eaedf3',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#495057',
                  backgroundColor: '#fff',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = '#21AA73';
                  e.target.style.color = '#21AA73';
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = '#eaedf3';
                  e.target.style.color = '#495057';
                }}
                onClick={() => handlePaymentMethodSelection('ACH')}
              >
                ACH
              </Button>
              <Button 
                theme="light" 
                block
                style={{
                  padding: '15px 20px',
                  border: '2px solid #eaedf3',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#495057',
                  backgroundColor: '#fff',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = '#21AA73';
                  e.target.style.color = '#21AA73';
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = '#eaedf3';
                  e.target.style.color = '#495057';
                }}
                onClick={() => handlePaymentMethodSelection('Money Order')}
              >
                Money Order
              </Button>
              <Button 
                theme="light" 
                block
                style={{
                  padding: '15px 20px',
                  border: '2px solid #eaedf3',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#495057',
                  backgroundColor: '#fff',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = '#21AA73';
                  e.target.style.color = '#21AA73';
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = '#eaedf3';
                  e.target.style.color = '#495057';
                }}
                onClick={() => handlePaymentMethodSelection('Offline Credit')}
              >
                Offline Credit
              </Button>
              <Button 
                theme="light" 
                block
                style={{
                  padding: '15px 20px',
                  border: '2px solid #eaedf3',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#495057',
                  backgroundColor: '#fff',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = '#21AA73';
                  e.target.style.color = '#21AA73';
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = '#eaedf3';
                  e.target.style.color = '#495057';
                }}
                onClick={() => handlePaymentMethodSelection('Other')}
              >
                Other
              </Button>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button 
              theme="light" 
              onClick={() => setShowPaymentMethodModal(false)}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>

        {/* Note Modal */}
        <Modal size={'md'} open={showNoteModal} toggle={() => setShowNoteModal(false)}>
          <ModalHeader toggle={() => setShowNoteModal(false)}>Add Note</ModalHeader>
          <ModalBody>
            <div className="mb-2" style={{ color: '#818ea3', fontSize: 13 }}>
              Notes added here are <b>for internal use only</b> and are not visible to customers.
            </div>
            <FormTextarea
              value={noteText}
              onChange={e => setNoteText(e.target.value)}
              placeholder="Enter your note..."
              style={{minHeight: 100}}
              disabled={savingNote}
            />
          </ModalBody>
          <ModalFooter>
            <Button theme="light" onClick={() => setShowNoteModal(false)} disabled={savingNote}>Cancel</Button>
            <Button theme="accent" onClick={handleAddNote} disabled={savingNote || !noteText.trim()}>
              {savingNote ? 'Saving...' : 'Save Note'}
            </Button>
          </ModalFooter>
        </Modal>

        {/* Respond Modal */}
        <Modal size={'md'} open={showRespondModal} toggle={() => setShowRespondModal(false)}>
          <ModalHeader toggle={() => setShowRespondModal(false)}>Respond to Dispute</ModalHeader>
          <ModalBody>
            <div className="mb-2" style={{ color: '#818ea3', fontSize: 13 }}>
              Select a canned message or write your own response to the person disputing. This will be sent to their email address.
            </div>
            <label className="field-label mb-1">Canned Message</label>
            <select
              className="form-control mb-3"
              value={selectedCannedMessage}
              onChange={e => {
                setSelectedCannedMessage(e.target.value);
                setCustomMessage(e.target.value);
              }}
            >
              <option value="">-- Select a canned message --</option>
              {cannedMessages.map((msg, idx) => (
                <option key={idx} value={msg}>{msg}</option>
              ))}
            </select>
            <label className="field-label mb-1">Your Message</label>
            <FormTextarea
              value={customMessage}
              onChange={e => setCustomMessage(e.target.value)}
              placeholder="Type your message here..."
              style={{minHeight: 100}}
            />
          </ModalBody>
          <ModalFooter>
            <Button theme="light" onClick={() => setShowRespondModal(false)}>Cancel</Button>
            <Button theme="accent" disabled={!customMessage.trim()} onClick={handleRespond}>
              Send Email
            </Button>
          </ModalFooter>
        </Modal>

        {/* Activity Note Modal */}
        <Modal size={'sm'} open={showActivityNote} toggle={() => setShowActivityNote(false)}>
          <ModalHeader toggle={() => setShowActivityNote(false)}>Dispute Response Note</ModalHeader>
          <ModalBody>
            <div style={{whiteSpace: 'pre-line', color: '#495057', fontSize: 15}}>{activityNoteContent}</div>
          </ModalBody>
          <ModalFooter>
            <Button theme="accent" onClick={() => setShowActivityNote(false)}>Close</Button>
          </ModalFooter>
        </Modal>
      </Container>
    );
  } else {
    return (
      <Container fluid className="main-content-container px-4">
        <div className="text-center py-5" style={{marginTop: '100px'}}>
          <ActivityIndicator size="large" />
          <p className="mt-3 text-muted">Loading citation...</p>
        </div>
      </Container>
    )
  }
  
}

export default Citation;
